import { instance } from '../instance'

/**
 * Validate password reset token action
 *
 * @param token
 * @param region
 * @returns {Promise<AxiosResponse<any>>}
 */
export const validatePasswordToken = (token, region) => {
  return instance.head(`/v1/auth/password/reset/${token}`, {
    params: { r: region },
  })
}
